import React from "react";
import {
  Layout,
  Row,
  Col,
  Select
} from "antd";
import logo from "../../assets/logo.png";
import AnalysisContainer from "./AnalysisContainer";
import GapAnalysisContainer from "./GapAnalysisContainer";
import NavigationContainer from "./NavigationContainer";
import DriverContainer from "./DriverContainer";
import { Link } from "react-router-dom";
import Report from "./Report";
import {
  REPORT,
  GAPANALYSIS,
  ANALYSIS,
  DRIVERS
} from "../../modules/results/constants";
const { Header, Content, Footer } = Layout;
const Option = Select.Option;

function renderSteps(step) {
  switch (step) {
    case REPORT:
      return <Report />;
    case GAPANALYSIS:
      return <GapAnalysisContainer />;
    case ANALYSIS:
      return <AnalysisContainer />;

    case DRIVERS:
      return <DriverContainer />;
    default:
      return <AnalysisContainer />;
  }
}
function SurveyResults(props) {
  return (
    <Layout className="layout">
      <Header className="" style={{ minHeight: "150px" }}>
        <Row>
          <Col md={12} offset={6}>
            <div className="logo">
              <Link to="/">
                <img alt='survey-results' src={logo} height="70px" />
              </Link>
            </div>
          </Col>
        </Row>

        <div className="header_navigation_language">
          <Select
            labelInValue
            defaultValue={{ key: props.language }}
            value={{ key: props.language }}
            style={{ width: 120 }}
            onChange={({ key }) => props.changeLanguage(key)}
          >
            <Option value="dk">Dansk</Option>
            <Option value="en">English</Option>
          </Select>
        </div>
      </Header>
      <Content>
        {renderSteps(props.step)}
        <Row>
          <NavigationContainer />
        </Row>
      </Content>
      <Footer style={{ backgroundColor: "#0B0B0B" }}>
        <Row>
          <Col
            md={{ span: 2, offset: 0 }}
            xs={24}
            style={{ paddingBottom: "20px" }}
          >
            <Link to={"/"}>
              <img alt='survey-results' src={logo} style={{ width: "150px" }} />
            </Link>
          </Col>
        </Row>
      </Footer>
    </Layout>
  );
}

export default SurveyResults;



// WEBPACK FOOTER //
// ./src/pages/SurveyResults/index.js